import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { HttpClient } from '@angular/common/http';
import {Observable} from "rxjs/Rx";
import { of } from 'rxjs/observable/of';
import { HttpHeaders } from '@angular/common/http';

import { oAuth } from './oAuth';
import { oAuthPost } from './oAuthPost';
import { URLSearchParams } from '@angular/http';

import { GlobalVariable } from '../common/global';

import { Pharmacies } from '../dataObjects/Pharmacies';
import 'rxjs/add/operator/map'
@Injectable()
export class AuthService {
    jwtHelper: JwtHelper = new JwtHelper();
    constructor(private http: HttpClient) { }

    public isAuthenticated(): Observable<boolean> {
        const token = sessionStorage.getItem('data');
        
        if (token == null) {
            return of(false);
        }
        else {
            const tokenPayload = <oAuth>JSON.parse((token));
            if (tokenPayload == null) {
                return of(false);
            }

            if (tokenPayload.access_token.length > 0) {

                let options = {
                    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token)
                };

               return this.http.get(GlobalVariable.BASE_API_URL + "/api/testAuth", options).map(res => true).catch(err => Observable.throw(false));
            }
        }
    }

    authenticateToken(token: string) {

        let tempAuth: oAuth = {
            token_type: 'bearer',
            access_token: token
        }

        sessionStorage.setItem('data', JSON.stringify(tempAuth));
    }

    authenticate(email: string, password: string): boolean {

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };

        let body = new URLSearchParams();
        body.set('grant_type', 'password');
        body.set('username', email);
        body.set('password', password);

        this.http.post<oAuth>(GlobalVariable.BASE_API_URL + "/api/security/token", body.toString(), options)
            .subscribe(
            (response) => {
                /* this function is executed every time there's a new output */
                    sessionStorage.setItem('data', JSON.stringify(response));
                //this.pingApi(response)
            },
            (err) => {
                /* this function is executed when there's an ERROR */
                //console.log("ERROR: " + err);
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                //console.log("COMPLETED");
                return true;
            }
        );
        return false;
    }

    pingApi(loginfo: oAuth): boolean {

        console.log(loginfo);

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + loginfo.access_token.toString())
        };

        this.http.get(GlobalVariable.BASE_API_URL + "/api/testAuth", options)
            .subscribe(
            (response) => {
                /* this function is executed every time there's a new output */
                return true;
            },
            (err) => {
                /* this function is executed when there's an ERROR */
                //console.log("ERROR: " + err);
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                return true;
            }
            );

        return false
    }

    ApiAuth(token: string): boolean {


        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + token)
        };

        this.http.get(GlobalVariable.BASE_API_URL + "/api/testAuth", options)
            .subscribe(
            (response) => {
                /* this function is executed every time there's a new output */
                console.log(response);
                return true;
            },
            (err) => {
                /* this function is executed when there's an ERROR */
                //console.log("ERROR: " + err);
                return false;
            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                return true;
            }
            );
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/auth.service.ts